import { render, staticRenderFns } from "./AdsROI.vue?vue&type=template&id=778c3204&scoped=true&"
import script from "./AdsROI.vue?vue&type=script&lang=js&"
export * from "./AdsROI.vue?vue&type=script&lang=js&"
import style0 from "./AdsROI.vue?vue&type=style&index=0&id=778c3204&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778c3204",
  null
  
)

export default component.exports